import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';

import Table from '../../../shared/table/Table';

const UsersTable = ({ data, page, handleUpdate, handleOpen, handleAddBalance }) => {
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  return (
    <Table>
      <thead>
        <tr>
          <th>#</th>
          <th>{t('pages.users.name')}</th>
          <th>{t('pages.users.email')}</th>
          <th>نوع الحساب</th>
          <th>{t('pages.users.is_active')}</th>
          <th>{t('general.action')}</th>
        </tr>
      </thead>
      <tbody>
        {data.map((el, index) => (
          <tr key={el._id}>
            <td>{((page - 1) * 10) + (index + 1)}</td>
            <td>{el.name}</td>
            <td>{el.email}</td>
            <td>{el.role?.name ?? el.type}</td>
            <td>{el.is_active ? t('general.yes') : t('general.no')}</td>
            <td>
              <Button
                bg="transparent" color="green" size="xs"
                onClick={() => handleUpdate(el)}
              >
                <FiIcons.FiEdit size={20} />
              </Button>
              <Button
                bg="transparent" color="orange" size="xs"
                title="إضافة رصيد"
                onClick={() => handleAddBalance(el)}
              >
                <FiIcons.FiDollarSign size={20} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default UsersTable